var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlbumOwner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "owner",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19333",
    "data-name": "Gruppe 19333",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19339",
    "data-name": "Gruppe 19339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19334",
    "data-name": "Gruppe 19334"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24706",
    "data-name": "Rechteck 24706",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19335",
    "data-name": "Gruppe 19335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284118",
    "data-name": "Pfad 284118",
    d: "M25.5,23.075A4.575,4.575,0,1,1,30.075,18.5,4.581,4.581,0,0,1,25.5,23.075Zm0-8A3.425,3.425,0,1,0,28.925,18.5,3.428,3.428,0,0,0,25.5,15.075Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19336",
    "data-name": "Gruppe 19336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284119",
    "data-name": "Pfad 284119",
    d: "M17.5,34.075a.576.576,0,0,1-.575-.575A8.58,8.58,0,0,1,28.49,25.461a.575.575,0,1,1-.4,1.078A7.43,7.43,0,0,0,18.075,33.5.576.576,0,0,1,17.5,34.075Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19337",
    "data-name": "Gruppe 19337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284120",
    "data-name": "Pfad 284120",
    d: "M32.795,37H30.2l-.314-1.313a4.43,4.43,0,0,1-.689-.332,4.628,4.628,0,0,1-.54-.38l-1.3.378L26.082,33.1l.981-.922a4.413,4.413,0,0,1,.005-1.362l-.986-.925,1.285-2.248,1.3.378a4.423,4.423,0,0,1,1.223-.711L30.2,26h2.59l.312,1.305a4.465,4.465,0,0,1,1.234.719l1.292-.376L36.918,29.9l-.981.922a4.475,4.475,0,0,1,0,1.362l.985.926-1.285,2.247-1.3-.378a4.421,4.421,0,0,1-1.224.712Zm-1.8-1h1.012l.262-1.091.271-.084a3.438,3.438,0,0,0,1.331-.773l.208-.195,1.078.315.5-.879-.816-.768.06-.277a3.44,3.44,0,0,0,.005-1.5l-.061-.277.812-.763-.5-.879-1.071.313-.208-.194a3.456,3.456,0,0,0-1.34-.782l-.272-.084L32.006,27H30.994l-.262,1.092-.271.084a3.43,3.43,0,0,0-1.33.772l-.208.195-1.079-.315-.5.878.818.769-.061.278a3.421,3.421,0,0,0-.006,1.5l.061.277-.812.763.5.878,1.071-.312.207.191a3.644,3.644,0,0,0,.593.447,3.521,3.521,0,0,0,.75.331l.269.086Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19338",
    "data-name": "Gruppe 19338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284121",
    "data-name": "Pfad 284121",
    d: "M31.5,33.05a1.55,1.55,0,1,1,1.55-1.55A1.553,1.553,0,0,1,31.5,33.05Zm0-2.1a.55.55,0,1,0,.55.55A.551.551,0,0,0,31.5,30.95Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumOwner);
export default __webpack_public_path__ + "static/media/album_owner.09e3026d0602bb7bc448e4faf31699f4.svg";
export { ForwardRef as ReactComponent };